export default class ropeEndings {
    constructor(props) {
        this.props = props
        this.observer = props.observer
        this.data = this.props.data
        this.keys = this.props.keys
        this.swrForm = document.createElement('form')
    }
    render() {
        this.swrForm.setAttribute('class', 'rope-form')
        this.swrForm.id = 'rope_form'
        const endings = this.data.options.swrOptions.endings
        const packingList = this.data.options.swrOptions.packingList
        const ropeEndA = this.generateSelect('rope_ending_a', `${window.globals.trans('filter.end_a')}`, endings)
        const ropeEndB = this.generateSelect('rope_ending_b', `${window.globals.trans('filter.end_b')}`, endings)
        const ropeLength = this.generateNumericInput('rope_length', `${window.globals.trans('filter.rope_length')}`, 'any')
        const packingType = this.generateSelect('packing_type', `${window.globals.trans('filter.packing_type')}`, packingList)
        this.swrForm.innerHTML = `
            <div class="row justify-center">
                <div class="col-lg-6 mb-2">
                    ${ropeEndA.outerHTML}
                </div>
                <div class="col-lg-6 mb-2">
                    ${ropeEndB.outerHTML}
                </div>
                <div class="col-lg-6 mb-2">
                    ${packingType.outerHTML}
                </div>
                <div class="col-lg-6 mb-2">
                    ${ropeLength.outerHTML}
                </div>
            </div>`
        this.initEventListeners()
        return this.swrForm
    }

    initEventListeners() {
        const numeric = this.swrForm.querySelector('.numeric-input')
        numeric.addEventListener('input', (e) => {
            if (this.isNumberKey(e)) {
                if (e.target.value === '0') {
                    e.target.value = '1'
                }
                this.observer.publish('ropeLength', e.target.value)
            }
        })
    }

    initSelectric() {
        const formSelects = this.swrForm.getElementsByClassName('filter-select')
        $(formSelects).selectric()
    }

    isNumberKey(evt) {
        const charCode = evt.which ? evt.which : evt.keyCode
        if (charCode === 46 || (charCode > 31 && (charCode < 48 || charCode > 57))) {
            evt.preventDefault()
            return false
        }
        return true
    }

    generateNumericInput(name, label, step) {
        const wrapper = document.createElement('div')
        const inputElem = document.createElement('input')
        const inputLabel = document.createElement('label')
        wrapper.classList.add('field-wrapper')
        inputLabel.classList.add('required')
        inputLabel.innerText = label
        inputElem.id = name
        inputElem.name = name
        inputElem.classList.add('numeric-input', 'd-block')
        inputElem.type = 'number'
        inputElem.setAttribute('value', 1)
        inputElem.min = 1
        inputElem.step = step
        wrapper.appendChild(inputLabel)
        wrapper.appendChild(inputElem)

        return wrapper
    }

    generateOption(value, label, isDefault = false) {
        const optionElem = document.createElement('option')
        optionElem.setAttribute('value', value)
        if (isDefault) {
            optionElem.setAttribute('disabled', true)
            optionElem.setAttribute('selected', true)
        }
        optionElem.innerText = label
        return optionElem
    }

    generateSelect(id, label, options) {
        const wrapper = document.createElement('div')
        const selectElem = document.createElement('select')
        const inputLabel = document.createElement('label')
        wrapper.classList.add('field-wrapper')
        inputLabel.classList.add('required')
        inputLabel.innerText = label
        selectElem.id = id
        selectElem.classList.add('filter-select')
        selectElem.appendChild(this.generateOption('', `${window.globals.trans('filter.select_type')}`, true))
        options.map((option) => {
            selectElem.appendChild(this.generateOption(option.id, option.label))
        })

        wrapper.appendChild(inputLabel)
        wrapper.appendChild(selectElem)

        return wrapper
    }
}
